import { Context } from '#store/overmind';
import { logger } from '#utils';
import { ParentalControlSetupViews } from '#store/namespaces/parental-control-setup/state';

export const setView = async (
  { state }: Context,
  view: ParentalControlSetupViews
) => {
  try {
    state.parentalControlSetup.view = view;
  } catch (e) {
    logger.warn('Could not disable parental control', { message: e.message });
  }
};

export const disableParentalControl = async ({
  state,
  actions,
  effects,
}: Context) => {
  try {
    const response = await effects.user.api.disableParentalControl();
    const responseData = response.data;
    const { pinSettingsStatus } = responseData;
    state.user.pinSettingsStatus = pinSettingsStatus ?? 'not_configured';
    actions.parentalControlSetup.setView(
      ParentalControlSetupViews.DISABLE_SUCCESS
    );
  } catch (e) {
    logger.warn('Could not disable parental control', { message: e.message });
  }
};
